import React, { useState, useEffect } from "react";
import {
    Tab, Button, Table, TableBody, TableCell, tableCellClasses, TableContainer, Container, TableRow, Paper, styled, Card, Box, TextField, Accordion, Typography, AccordionSummary, AccordionDetails
} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import { GetFantasyPoints, ResetFantasyPoints, ResetUpdateFantasyPoints, UpdateFantasyPoints } from "src/redux/actions/PointsManagementAction";
import { toast } from "react-toastify";
import HeaderBreadcrumbs from "./../../components/HeaderBreadcrumbs";
import Page from "./../../components/Page";
import Loader from "src/components/Loader";
import { ExpandMore } from "@mui/icons-material";
import "./PointsManagement.css"

const CricketPointsManagement = () => {
    const dispatch = useDispatch();
    const StatePoints = useSelector((state) => state.points.fantasy_points?.data?.fantasy_data);
    const PointsUpdateMsg = useSelector((state) => state.points.fantasy_points_update_message);
    const loadingSelector = useSelector((state) => state.points.loading);
    const cricketPointsArray = StatePoints?.length >= 0 && StatePoints.filter((elem) => elem.game_id === 1);
    const [value, setValue] = useState(cricketPointsArray ? cricketPointsArray?.[0]?.type : "test")
    const [cricketPointsObj, setCricketPointsObj] = useState({
        "points.wicket": 16,
        "points.tenwhb": 0,
        "runs_conceded": 0,
        "points.catch": 8,
        "points.catchthree": 4,
        "points.catchfive": 5,
        "points.run": 1,
        "points.six": 2,
        "points.four": 1,
        "points.thirty": 2,
        "points.fifty": 4,
        "points.hundred": 8,
        "points.onefifty": 10,
        "points.twohundred": 12,
        "points.duck": -8,
        "points.mdnover": 0,
        "points.stumped": 12,
        "points.cap": 2,
        "points.vcap": 1.5,
        "points.playing": 4,
        "points.threewhb": 3,
        "points.fourwhb": 4,
        "points.fivewhb": 8,
        "points.runout": 12,
        "points.thrower": 8,
        "points.catcher": 4,
        "points.srone": 0,
        "points.srtwo": 0,
        "points.srthree": 0,
        "points.srfour": 0,
        "points.srfive": 0,
        "points.srsix": 0,
        "points.erone": 0,
        "points.ertwo": 0,
        "points.erthree": 0,
        "points.erfour": 0,
        "points.erfive": 0,
        "points.ersix": 0,
        "points.erseven": 0,
        "points.srmball": 0,
        "points.ermover": 0,
        "points.playing11": 4,
        "points.lbwbns": 4,
        "points.directhit": 8,
    });

    useEffect(() => {
        dispatch(GetFantasyPoints());
        return () => dispatch(ResetFantasyPoints())
    }, [dispatch]);

    useEffect(() => {
        if (Object.keys(PointsUpdateMsg).length > 0) {
            if (PointsUpdateMsg.data.status) {
                toast.success(PointsUpdateMsg.data.message, { theme: "colored" })
                dispatch(GetFantasyPoints());
                dispatch(ResetUpdateFantasyPoints())
            }
        }
    }, [PointsUpdateMsg])

    const handleChange = (_, newValue) => {
        setValue(newValue);
    };

    const handleInputChange = (key, value) => {
        cricketPointsObj[key] = Number(value);
        setCricketPointsObj(cricketPointsObj);
    };

    const handleUpdate = (type, game_id) => {
        const sendData = {
            game_id: game_id,
            type: type,
            points: cricketPointsObj,
        };
        dispatch(UpdateFantasyPoints(sendData));
    };

    return (
        <Page title="Points Management">
            {loadingSelector ? <Loader /> : null}
            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading="Cricket Points Management"
                    links={[{ name: "Dashboard", href: "/dashboard/app" },
                    { name: "Cricket Points Management" }]}
                />
                <Card
                    sx={{ padding: "20px", marginTop: "20px" }}
                    className="points-card-block"
                >
                    <TabContext value={value}>
                        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                            <TabList onChange={handleChange} aria-label="Points management Tabs">
                                {cricketPointsArray &&
                                    cricketPointsArray.map((elem, index) => (
                                        <Tab label={elem.type.toUpperCase()} value={elem.type} key={index} />
                                    ))}
                            </TabList>
                        </Box>
                        {cricketPointsArray &&
                            cricketPointsArray.map((elem, index) =>
                                elem.type === "test" ? (
                                    <TabPanel value={elem.type} key={index}>
                                        <Accordion className="accordion-point-body">
                                            <AccordionSummary
                                                expandIcon={<ExpandMore />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                                className="accordion-point-header"
                                            >
                                                <Typography> Batting </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className="accordion-point-content">
                                                <TableContainer>
                                                    <Table>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> For every run </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.run", target.value)
                                                                        }
                                                                        defaultValue={elem.points["run"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Boundary Bonus </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.four", target.value)
                                                                        }
                                                                        defaultValue={elem.points["four"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Six Bonus </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.six", target.value)
                                                                        }
                                                                        defaultValue={elem.points["six"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 50 runs </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.fifty", target.value)
                                                                        }
                                                                        defaultValue={elem.points["fifty"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 100 runs </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.hundred",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["hundred"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 150 runs </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.onefifty",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["onefifty"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 200 runs </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.twohundred",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["twohundred"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Duck </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.duck", target.value)
                                                                        }
                                                                        defaultValue={elem.points["duck"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Appearance  Playing 11 </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.playing11",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["playing11"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion className="accordion-point-body">
                                            <AccordionSummary
                                                expandIcon={<ExpandMore />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                                className="accordion-point-header"
                                            >
                                                <Typography> Bowling </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className="accordion-point-content">
                                                <TableContainer>
                                                    <Table>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> wicket </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.wicket", target.value)
                                                                        }
                                                                        defaultValue={elem.points["wicket"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 4 wicket </TableCell>
                                                                <TableCell align="right"> - </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 5 wicket </TableCell>
                                                                <TableCell align="right"> - </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 10 wickets in match </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.tenwhb", target.value)
                                                                        }
                                                                        defaultValue={elem.points["tenwhb"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Bowled/ LBW bonus </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.lbwbns", target.value)
                                                                        }
                                                                        defaultValue={elem.points["lbwbns"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Appearance Playing 11 </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.playing11",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["playing11"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion className="accordion-point-body">
                                            <AccordionSummary
                                                expandIcon={<ExpandMore />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                                className="accordion-point-header"
                                            >
                                                <Typography> Fielding </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className="accordion-point-content">
                                                <TableContainer>
                                                    <Table>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Catch </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.catch", target.value)
                                                                        }
                                                                        defaultValue={elem.points["catch"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Direct Hit </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.directhit",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["directhit"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Catcher </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.catcher",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["catcher"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Thrower </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.thrower",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["thrower"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Runout </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.runout", target.value)
                                                                        }
                                                                        defaultValue={elem.points["runout"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Stumping </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.stumped",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["stumped"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 3 catch  bonus </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.catchthree",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["catchthree"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 5 catch bonus </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.catchfive",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["catchfive"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 5 dismissals bonus (WK) </TableCell>
                                                                <TableCell align="right"> - </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 10 dismissals bonus (WK) </TableCell>
                                                                <TableCell align="right"> - </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </AccordionDetails>
                                        </Accordion>
                                        <br />
                                        <div align="right">
                                            <Button
                                                onClick={() => handleUpdate(elem.type, elem.game_id)}
                                                variant="contained"
                                                color="primary"
                                                size="large"
                                            >
                                                Update
                                            </Button>
                                        </div>
                                    </TabPanel>
                                ) : (
                                    ""
                                ),
                            )}
                        {cricketPointsArray &&
                            cricketPointsArray.map((elem, index) =>
                                elem.type === "t20" ? (
                                    <TabPanel value={elem.type} key={index}>

                                        <Accordion className="accordion-point-body">
                                            <AccordionSummary
                                                expandIcon={<ExpandMore />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                                className="accordion-point-header"
                                            >
                                                <Typography> Batting </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className="accordion-point-content">
                                                <TableContainer>
                                                    <Table>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> For every run </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.run", target.value)
                                                                        }
                                                                        defaultValue={elem.points["run"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Boundary Bonus </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.four", target.value)
                                                                        }
                                                                        defaultValue={elem.points["four"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Six Bonus </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.six", target.value)
                                                                        }
                                                                        defaultValue={elem.points["six"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 30 run Bonus </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.thirty", target.value)
                                                                        }
                                                                        defaultValue={elem.points["thirty"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Half century </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.fifty", target.value)
                                                                        }
                                                                        defaultValue={elem.points["fifty"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Century bonus  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.hundred",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["hundred"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 150 run bonus  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.onefifty",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["onefifty"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Duck  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.duck", target.value)
                                                                        }
                                                                        defaultValue={elem.points["duck"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Appearance Playing 11  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.playing11",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["playing11"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> {`Strike Rate < 80`}  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.srone", target.value)
                                                                        }
                                                                        style={{ background: "white" }}
                                                                        defaultValue={elem.points["srone"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Strike Rate 80-100  </TableCell>
                                                                <TableCell align="right"> - </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Strike Rate 115-130 </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.srthree",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["srthree"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Strike Rate 130-170  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.srfour", target.value)
                                                                        }
                                                                        defaultValue={elem.points["srfour"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Strike Rate 170-190  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.srfive", target.value)
                                                                        }
                                                                        defaultValue={elem.points["srfive"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> {`Strike Rate > 190 `} </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.srsix", target.value)
                                                                        }
                                                                        defaultValue={elem.points["srsix"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion className="accordion-point-body">
                                            <AccordionSummary
                                                expandIcon={<ExpandMore />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                                className="accordion-point-header"
                                            >
                                                <Typography> Bowling </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className="accordion-point-content">
                                                <TableContainer>
                                                    <Table>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> wicket </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.wicket", target.value)
                                                                        }
                                                                        defaultValue={elem.points["wicket"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 3 wicket </TableCell>
                                                                <TableCell align="right"> </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 4 wicket </TableCell>
                                                                <TableCell align="right"> </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 5 wicket </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.catchfive",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["catchfive"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Maiden </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.mdnover",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["mdnover"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Per Boundary Conceded  </TableCell>
                                                                <TableCell align="right"> </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Bowled/ LBW bonus  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.lbwbns", target.value)
                                                                        }
                                                                        defaultValue={elem.points["lbwbns"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Appearance Playing 11  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.playing11",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["playing11"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> {`Economy Rate < 5`}  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.erone", target.value)
                                                                        }
                                                                        defaultValue={elem.points["erone"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Economy Rate 5-6.5  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.ertwo", target.value)
                                                                        }
                                                                        defaultValue={elem.points["ertwo"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Economy Rate 6.5 - 7.5  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.erthree",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["erthree"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Economy Rate 7.5-8  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.erfour", target.value)
                                                                        }
                                                                        defaultValue={elem.points["erfour"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Economy Rate 9-12   </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.erfive", target.value)
                                                                        }
                                                                        defaultValue={elem.points["erfive"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> {`Economy Rate > 12`}  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.ersix", target.value)
                                                                        }
                                                                        defaultValue={elem.points["ersix"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Runs Conceded  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.runs_conceded", target.value)
                                                                        }
                                                                        defaultValue={elem.points["runs_conceded"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion className="accordion-point-body">
                                            <AccordionSummary
                                                expandIcon={<ExpandMore />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                                className="accordion-point-header"
                                            >
                                                <Typography> Fielding </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className="accordion-point-content">
                                                <TableContainer>
                                                    <Table>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Catch </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.catch", target.value)
                                                                        }
                                                                        defaultValue={elem.points["catch"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Direct Hit </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.directhit",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["directhit"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Thrower </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.thrower",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["thrower"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Catcher </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.catcher",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["catcher"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Runout </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.runout", target.value)
                                                                        }
                                                                        defaultValue={elem.points["runout"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Stumping  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.stumped",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["stumped"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 3 catch bonus  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.catchthree",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["catchthree"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 5 dismissals bonus (WK)  </TableCell>
                                                                <TableCell align="right"> - </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </AccordionDetails>
                                        </Accordion>

                                        <br />

                                        <div align="right">
                                            <Button
                                                onClick={() => handleUpdate(elem.type, elem.game_id)}
                                                variant="contained"
                                                color="primary"
                                                size="large"
                                            >
                                                Update
                                            </Button>
                                        </div>
                                    </TabPanel>
                                ) : (
                                    ""
                                ),
                            )}
                        {cricketPointsArray &&
                            cricketPointsArray.map((elem, index) =>
                                elem.type === "odi" ? (
                                    <TabPanel value={elem.type} key={index}>
                                        <Accordion className="accordion-point-body">
                                            <AccordionSummary
                                                expandIcon={<ExpandMore />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                                className="accordion-point-header"
                                            >
                                                <Typography> Batting </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className="accordion-point-content">
                                                <TableContainer>
                                                    <Table>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> For every run </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.run", target.value)
                                                                        }
                                                                        defaultValue={elem.points["run"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Boundary Bonus </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.four", target.value)
                                                                        }
                                                                        defaultValue={elem.points["four"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Six Bonus </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.six", target.value)
                                                                        }
                                                                        defaultValue={elem.points["six"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 30 run Bonus </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.thirty", target.value)
                                                                        }
                                                                        defaultValue={elem.points["thirty"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Half century </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.fifty", target.value)
                                                                        }
                                                                        defaultValue={elem.points["fifty"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Century bonus  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.hundred",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["hundred"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Duck  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.duck", target.value)
                                                                        }
                                                                        defaultValue={elem.points["duck"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Appearance Playing 11  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.playing11",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["playing11"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> {`Strike Rate < 90`}  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.srone", target.value)
                                                                        }
                                                                        style={{ background: "white" }}
                                                                        defaultValue={elem.points["srone"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Strike Rate 90-110 </TableCell>
                                                                <TableCell align="right"> - </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Strike Rate 130-140 </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.srthree",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["srthree"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Strike Rate 140-180  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.srfour", target.value)
                                                                        }
                                                                        defaultValue={elem.points["srfour"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Strike Rate 180-200  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.srfive", target.value)
                                                                        }
                                                                        defaultValue={elem.points["srfive"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> {`Strike Rate > 200 `} </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.srsix", target.value)
                                                                        }
                                                                        defaultValue={elem.points["srsix"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion className="accordion-point-body">
                                            <AccordionSummary
                                                expandIcon={<ExpandMore />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                                className="accordion-point-header"
                                            >
                                                <Typography> Bowling </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className="accordion-point-content">
                                                <TableContainer>
                                                    <Table>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> wicket </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.wicket", target.value)
                                                                        }
                                                                        defaultValue={elem.points["wicket"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 3 wicket </TableCell>
                                                                <TableCell align="right"> </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 4 wicket </TableCell>
                                                                <TableCell align="right"> </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 5 wicket </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.catchfive",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["catchfive"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Maiden </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.mdnover",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["mdnover"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Per Boundary Conceded  </TableCell>
                                                                <TableCell align="right"> </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Bowled/ LBW bonus  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.lbwbns", target.value)
                                                                        }
                                                                        defaultValue={elem.points["lbwbns"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Appearance Playing 11  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.playing11",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["playing11"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> {`Economy Rate < 6`}  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.erone", target.value)
                                                                        }
                                                                        defaultValue={elem.points["erone"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Economy Rate 6-7.5 </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.ertwo", target.value)
                                                                        }
                                                                        defaultValue={elem.points["ertwo"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Economy Rate 7.5-8.5 </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.erthree",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["erthree"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Economy Rate 8.5- 9.5 </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.erfour", target.value)
                                                                        }
                                                                        defaultValue={elem.points["erfour"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Economy Rate 10-13 </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.erfive", target.value)
                                                                        }
                                                                        defaultValue={elem.points["erfive"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> {`Economy Rate > 13`}  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.ersix", target.value)
                                                                        }
                                                                        defaultValue={elem.points["ersix"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Runs Conceded  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.runs_conceded", target.value)
                                                                        }
                                                                        defaultValue={elem.points["runs_conceded"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion className="accordion-point-body">
                                            <AccordionSummary
                                                expandIcon={<ExpandMore />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                                className="accordion-point-header"
                                            >
                                                <Typography> Fielding </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className="accordion-point-content">
                                                <TableContainer>
                                                    <Table>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Catch </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.catch", target.value)
                                                                        }
                                                                        defaultValue={elem.points["catch"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Direct Hit </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.directhit",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["directhit"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Thrower </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.thrower",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["thrower"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Catcher </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.catcher",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["catcher"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Runout </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.runout", target.value)
                                                                        }
                                                                        defaultValue={elem.points["runout"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Stumping  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.stumped",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["stumped"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 3 catch bonus  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.catchthree",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["catchthree"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 5 dismissals bonus (WK)  </TableCell>
                                                                <TableCell align="right"> - </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </AccordionDetails>
                                        </Accordion>

                                        <br />

                                        <div align="right">
                                            <Button
                                                onClick={() => handleUpdate(elem.type, elem.game_id)}
                                                variant="contained"
                                                color="primary"
                                                size="large"
                                            >
                                                Update
                                            </Button>
                                        </div>
                                    </TabPanel>
                                ) : (
                                    ""
                                ),
                            )}
                        {cricketPointsArray &&
                            cricketPointsArray.map((elem, index) =>
                                elem.type === "t10" ? (
                                    <TabPanel value={elem.type} key={index}>

                                        <Accordion className="accordion-point-body">
                                            <AccordionSummary
                                                expandIcon={<ExpandMore />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                                className="accordion-point-header"
                                            >
                                                <Typography> Batting </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className="accordion-point-content">
                                                <TableContainer>
                                                    <Table>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> For every run </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.run", target.value)
                                                                        }
                                                                        defaultValue={elem.points["run"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Boundary Bonus </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.four", target.value)
                                                                        }
                                                                        defaultValue={elem.points["four"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Six Bonus </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.six", target.value)
                                                                        }
                                                                        defaultValue={elem.points["six"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 30 run Bonus </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.thirty", target.value)
                                                                        }
                                                                        defaultValue={elem.points["thirty"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Half century </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.fifty", target.value)
                                                                        }
                                                                        defaultValue={elem.points["fifty"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Century bonus  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.hundred",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["hundred"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 150 run bonus  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.onefifty",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["onefifty"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Duck  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.duck", target.value)
                                                                        }
                                                                        defaultValue={elem.points["duck"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Appearance Playing 11  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.playing11",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["playing11"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> {`Strike Rate < 90`}  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.srone", target.value)
                                                                        }
                                                                        style={{ background: "white" }}
                                                                        defaultValue={elem.points["srone"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Strike Rate 90-110  </TableCell>
                                                                <TableCell align="right"> - </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Strike Rate 130-140 </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.srthree",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["srthree"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Strike Rate 140-180  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.srfour", target.value)
                                                                        }
                                                                        defaultValue={elem.points["srfour"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Strike Rate 180-200  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.srfive", target.value)
                                                                        }
                                                                        defaultValue={elem.points["srfive"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> {`Strike Rate > 200 `} </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.srsix", target.value)
                                                                        }
                                                                        defaultValue={elem.points["srsix"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion className="accordion-point-body">
                                            <AccordionSummary
                                                expandIcon={<ExpandMore />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                                className="accordion-point-header"
                                            >
                                                <Typography> Bowling </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className="accordion-point-content">
                                                <TableContainer>
                                                    <Table>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> wicket </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.wicket", target.value)
                                                                        }
                                                                        defaultValue={elem.points["wicket"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 3 wicket </TableCell>
                                                                <TableCell align="right"> </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 4 wicket </TableCell>
                                                                <TableCell align="right"> </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 5 wicket </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.catchfive",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["catchfive"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Maiden </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.mdnover",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["mdnover"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Per Boundary Conceded  </TableCell>
                                                                <TableCell align="right"> </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Bowled/ LBW bonus  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.lbwbns", target.value)
                                                                        }
                                                                        defaultValue={elem.points["lbwbns"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Appearance Playing 11  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.playing11",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["playing11"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> {`Economy Rate < 6`}  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.erone", target.value)
                                                                        }
                                                                        defaultValue={elem.points["erone"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Economy Rate 6-7.5  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.ertwo", target.value)
                                                                        }
                                                                        defaultValue={elem.points["ertwo"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Economy Rate 7.5-8.5  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.erthree",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["erthree"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Economy Rate 8.5- 9.5 </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.erfour", target.value)
                                                                        }
                                                                        defaultValue={elem.points["erfour"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Economy Rate 10-13 </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.erfive", target.value)
                                                                        }
                                                                        defaultValue={elem.points["erfive"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> {`Economy Rate > 13`}  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.ersix", target.value)
                                                                        }
                                                                        defaultValue={elem.points["ersix"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Runs Conceded  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.runs_conceded", target.value)
                                                                        }
                                                                        defaultValue={elem.points["runs_conceded"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </AccordionDetails>
                                        </Accordion>

                                        <Accordion className="accordion-point-body">
                                            <AccordionSummary
                                                expandIcon={<ExpandMore />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                                className="accordion-point-header"
                                            >
                                                <Typography> Fielding </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className="accordion-point-content">
                                                <TableContainer>
                                                    <Table>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Catch </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.catch", target.value)
                                                                        }
                                                                        defaultValue={elem.points["catch"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Direct Hit </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.directhit",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["directhit"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Thrower </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.thrower",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["thrower"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Catcher </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.catcher",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["catcher"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Runout </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange("points.runout", target.value)
                                                                        }
                                                                        defaultValue={elem.points["runout"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> Stumping  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.stumped",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["stumped"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 3 catch bonus  </TableCell>
                                                                <TableCell align="right">
                                                                    <TextField
                                                                        type="number"
                                                                        onChange={({ target }) =>
                                                                            handleInputChange(
                                                                                "points.catchthree",
                                                                                target.value,
                                                                            )
                                                                        }
                                                                        defaultValue={elem.points["catchthree"]}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>

                                                            <TableRow>
                                                                <TableCell component="th" scope="row"> 5 dismissals bonus (WK)  </TableCell>
                                                                <TableCell align="right"> - </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </AccordionDetails>
                                        </Accordion>

                                        <br />

                                        <div align="right">
                                            <Button
                                                onClick={() => handleUpdate(elem.type, elem.game_id)}
                                                variant="contained"
                                                color="primary"
                                                size="large"
                                            >
                                                Update
                                            </Button>
                                        </div>
                                    </TabPanel>
                                ) : (
                                    ""
                                ),
                            )}
                    </TabContext>
                </Card>
            </Container>
        </Page>
    );
};

export default CricketPointsManagement;
